module.exports = __webpack_public_path__ + "img/dbc.ba55ad0e.svg";